function customizeNavbarSection(navbarSection) {
  
}

module.exports = customizeNavbarSection;
